<template>
  <div
    class="bg-card rounded-[16px] p-2 md:p-6 border border-border h-full flex flex-col"
  >
    <div class="flex items-center justify-between mb-4">
      <div>
        <h2 class="text-[16px] font-semibold text-card-foreground">
          Goals Status
        </h2>
        <p class="text-[11px] text-muted-foreground">By course completion</p>
      </div>
      <router-link
        to="/learning-goals"
        class="inline-flex items-center gap-2 whitespace-nowrap px-4 py-2 text-[11px] font-semibold bg-primary text-primary-foreground border border-primary rounded-[20px] hover:bg-primary/90 dark:bg-secondary dark:text-foreground dark:border dark:border-border dark:hover:bg-border transition-colors"
      >
        View Learning Dashboard
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.0013 1.33301C11.6746 1.33301 14.668 4.32634 14.668 7.99967C14.668 11.673 11.6746 14.6663 8.0013 14.6663C4.32797 14.6663 1.33464 11.673 1.33464 7.99967C1.33464 4.32634 4.32797 1.33301 8.0013 1.33301ZM6.80797 9.99967C6.61464 10.193 6.61464 10.513 6.80797 10.7063C6.90797 10.8063 7.03464 10.853 7.1613 10.853C7.28797 10.853 7.41464 10.8063 7.51464 10.7063L9.86797 8.35301C10.0613 8.15967 10.0613 7.83967 9.86797 7.64634L7.51464 5.29301C7.3213 5.09967 7.0013 5.09967 6.80797 5.29301C6.61464 5.48634 6.61464 5.80634 6.80797 5.99967L8.80797 7.99967L6.80797 9.99967Z"
            class="fill-current"
          />
        </svg>
      </router-link>
    </div>

    <!-- Chart.js Donut Chart -->
    <div class="relative mx-auto my-6 w-[228px] h-[228px]">
      <canvas
        ref="goalsChart"
        width="228"
        height="228"
        class="w-full h-full"
      ></canvas>
      <div
        class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none"
      >
        <span class="text-[32px] font-bold text-card-foreground">{{
          total
        }}</span>
        <span class="text-[12px] text-muted-foreground">Learning Goals</span>
      </div>
    </div>

    <!-- Legend -->
    <div class="flex items-center justify-center gap-4 mb-6 text-[11px]">
      <div class="flex items-center gap-1.5">
        <div class="w-2.5 h-2.5 rounded-full bg-[#4CAF50]"></div>
        <span class="text-muted-foreground">Completed</span>
      </div>
      <div class="flex items-center gap-1.5">
        <div class="w-2.5 h-2.5 rounded-full bg-[#C8C8D2]"></div>
        <span class="text-muted-foreground">Not Started</span>
      </div>
      <div class="flex items-center gap-1.5">
        <div class="w-2.5 h-2.5 rounded-full bg-[#FFA726]"></div>
        <span class="text-muted-foreground">Active</span>
      </div>
    </div>

    <!-- Recent Goal Card -->
    <div
      v-if="recentLearningGoal"
      class="mb-4 p-4 bg-muted/50 rounded-[12px] border border-border"
    >
      <div class="flex items-start gap-3 mb-3">
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M51.3333 11.3163V39.0596C51.3333 41.3229 49.49 43.3996 47.2267 43.6796L46.5033 43.7729C42.6767 44.2863 37.2867 45.8729 32.9467 47.6929C31.43 48.3229 29.75 47.1796 29.75 45.5229V13.0663C29.75 12.2029 30.24 11.4096 31.01 10.9896C35.28 8.6796 41.7433 6.62626 46.13 6.25293H46.27C49.07 6.25293 51.3333 8.51626 51.3333 11.3163Z"
            class="fill-foreground/80"
          />
          <path
            d="M24.9912 10.9896C20.7212 8.6796 14.2579 6.62626 9.8712 6.25293H9.70786C6.90786 6.25293 4.64453 8.51626 4.64453 11.3163V39.0596C4.64453 41.3229 6.48786 43.3996 8.7512 43.6796L9.47453 43.7729C13.3012 44.2863 18.6912 45.8729 23.0312 47.6929C24.5479 48.3229 26.2279 47.1796 26.2279 45.5229V13.0663C26.2279 12.1796 25.7612 11.4096 24.9912 10.9896ZM11.6679 18.0596H16.9179C17.8745 18.0596 18.6679 18.8529 18.6679 19.8096C18.6679 20.7896 17.8745 21.5596 16.9179 21.5596H11.6679C10.7112 21.5596 9.91786 20.7896 9.91786 19.8096C9.91786 18.8529 10.7112 18.0596 11.6679 18.0596ZM18.6679 28.5596H11.6679C10.7112 28.5596 9.91786 27.7896 9.91786 26.8096C9.91786 25.8529 10.7112 25.0596 11.6679 25.0596H18.6679C19.6245 25.0596 20.4179 25.8529 20.4179 26.8096C20.4179 27.7896 19.6245 28.5596 18.6679 28.5596Z"
            class="fill-foreground/80"
          />
        </svg>

        <div class="flex-1 min-w-0">
          <p class="text-[13px] font-semibold text-card-foreground truncate">
            {{ recentLearningGoal.title || "UX Design Foundations" }}
          </p>
          <div class="flex items-center gap-2 mt-2">
            <div
              class="flex-1 h-1.5 bg-muted-foreground/50 rounded-full overflow-hidden"
            >
              <div
                class="h-full bg-primary dark:bg-[#FFA726] rounded-full transition-all"
                :style="{ width: `${continueLearningProgress}%` }"
              ></div>
            </div>
          </div>
          <div class="flex items-center justify-between mt-2">
            <span class="text-[11px] text-muted-foreground"
              >{{ continueLearningProgress }}% complete</span
            >
            <div
              class="flex items-center gap-1 text-[11px] text-muted-foreground"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.8346 7.00033C12.8346 10.2203 10.2213 12.8337 7.0013 12.8337C3.7813 12.8337 1.16797 10.2203 1.16797 7.00033C1.16797 3.78033 3.7813 1.16699 7.0013 1.16699C10.2213 1.16699 12.8346 3.78033 12.8346 7.00033Z"
                  stroke="#ABABB3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.16516 8.85503L7.35682 7.77586C7.04182 7.58919 6.78516 7.14003 6.78516 6.77253V4.38086"
                  stroke="#ABABB3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              {{ continueLearningMeta }}
            </div>
          </div>
        </div>
      </div>
      <!-- Continue Learning Button -->
      <button
        type="button"
        @click="$emit('continue-learning')"
        class="mt-auto w-full bg-primary text-primary-foreground hover:bg-primary/90 dark:bg-background dark:text-foreground dark:border dark:border-border dark:hover:bg-border text-[12px] font-semibold py-3 rounded-[8px] transition-colors tracking-wide"
      >
        CONTINUE LEARNING
      </button>
    </div>
  </div>
</template>

<script>
import {
  Chart,
  ArcElement,
  DoughnutController,
  Tooltip,
  Legend,
} from "chart.js";

Chart.register(ArcElement, DoughnutController, Tooltip, Legend);

export default {
  name: "GoalsStatusCard",
  props: {
    total: { type: Number, default: 0 },
    completed: { type: Number, default: 0 },
    notStarted: { type: Number, default: 0 },
    active: { type: Number, default: 0 },
    recentLearningGoal: { type: Object, default: null },
    continueLearningProgress: { type: Number, default: 0 },
    continueLearningMeta: { type: String, default: "" },
  },
  data() {
    return {
      chart: null,
      isUnmounting: false,
    };
  },
  watch: {
    completed: { handler: "updateChart", flush: "post" },
    notStarted: { handler: "updateChart", flush: "post" },
    active: { handler: "updateChart", flush: "post" },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeUnmount() {
    this.isUnmounting = true;
    if (this.chart) {
      try {
        this.chart.destroy();
      } catch (e) {
        // ignore cleanup errors during unmount
      }
      this.chart = null;
    }
  },
  methods: {
    initChart() {
      if (this.isUnmounting) return;
      const ctx = this.$refs.goalsChart?.getContext("2d");
      if (!ctx) return;

      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }

      this.chart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Completed", "Not Started", "Active"],
          datasets: [
            {
              data: [this.completed, this.notStarted, this.active],
              backgroundColor: ["#4CAF50", "#C8C8D2", "#FFA726"],
              borderWidth: 0,
              borderRadius: 8,
              spacing: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: "75%",
          plugins: {
            legend: { display: false },
            tooltip: {
              enabled: true,
              backgroundColor: "#1A1A1A",
              titleColor: "#FFFFFF",
              bodyColor: "#FFFFFF",
              padding: 12,
              cornerRadius: 8,
              displayColors: true,
              callbacks: {
                label: function (context) {
                  const label = context.label || "";
                  const value = context.parsed || 0;
                  return `${label}: ${value} goal${value !== 1 ? "s" : ""}`;
                },
              },
            },
          },
        },
      });
    },
    updateChart() {
      if (this.isUnmounting) return;
      if (!this.$refs.goalsChart) return;

      if (!this.chart) {
        this.initChart();
        return;
      }

      try {
        if (!this.chart?.data?.datasets?.[0]) return;
        this.chart.data.datasets[0].data = [
          this.completed,
          this.notStarted,
          this.active,
        ];
        this.chart.update();
      } catch (e) {
        try {
          this.chart?.destroy?.();
        } catch (_) {
          // ignore
        }
        this.chart = null;
        this.$nextTick(() => this.initChart());
      }
    },
  },
};
</script>
